import { render, staticRenderFns } from "./homeBanner.vue?vue&type=template&id=04a37060&scoped=true&"
import script from "./homeBanner.vue?vue&type=script&lang=ts&"
export * from "./homeBanner.vue?vue&type=script&lang=ts&"
import style0 from "./homeBanner.vue?vue&type=style&index=0&id=04a37060&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a37060",
  null
  
)

export default component.exports